const certificateStatusCA =
    {
        es: [
            {code:'ALL', name: 'Cualquier Estado'},
            {code:'OK', name: 'Emitido'},
            {code:'REVOKED', name: "Revocado"},
            {code:'PENDING', name: "Pendiente"}
        ],
        en: [
            {code:'ALL', name: 'Any Status'},
            {code:'OK', name: 'Issued'},
            {code:'REVOKED', name: "Revoked"},
            {code:'PENDING', name: "Pending"}
        ]
    }
export default certificateStatusCA;